var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73726 2.3066C6.33738 1.76104 7.15131 1.45455 8 1.45455C8.84869 1.45455 9.66263 1.76104 10.2627 2.3066C10.8629 2.85216 11.2 3.5921 11.2 4.36364V6.54545H4.8V4.36364C4.8 3.5921 5.13714 2.85216 5.73726 2.3066ZM3.2 6.54545V4.36364C3.2 3.20633 3.70571 2.09642 4.60589 1.27808C5.50606 0.459739 6.72696 0 8 0C9.27304 0 10.4939 0.459739 11.3941 1.27808C12.2943 2.09642 12.8 3.20633 12.8 4.36364V6.54545H13.6C14.9255 6.54545 16 7.52229 16 8.72727V13.8182C16 15.0232 14.9255 16 13.6 16H2.4C1.07452 16 0 15.0232 0 13.8182V8.72727C0 7.52229 1.07452 6.54545 2.4 6.54545H3.2ZM12 8H4H2.4C1.95817 8 1.6 8.32561 1.6 8.72727V13.8182C1.6 14.2198 1.95817 14.5455 2.4 14.5455H13.6C14.0418 14.5455 14.4 14.2198 14.4 13.8182V8.72727C14.4 8.32561 14.0418 8 13.6 8H12Z",
    fill: "#4F86DA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-outline.75ee9455e6c12de2f5ef86083c25d908.svg";